import {IQuotesGallery} from "./interfaces";
import React from "react";
import {getJSONFromHtml, isMobile} from "../../../domain/common";
import Imgix from "react-imgix";
import ArrowIcon from "../../../ui/svg/common/arrow";


interface IQuotesGalleryProps {
    quotesGallery?: IQuotesGallery[],
}

interface ICarouselSlideItemProps {
    pos:number,
    idx:number,
    activeIdx:number,
    isFirst:boolean,
    isLast: boolean
}
/**
 * the entry point
 */
const QuotesGallery = (props?: IQuotesGalleryProps) => {
    const ImageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase()
    let qGallery= getJSONFromHtml(document.getElementById('product-quote-gallery-data')) as IQuotesGallery[];
    const centerGallaryFix = qGallery.length < 7 ? 2 : 3;
    const positionGallaryFix = qGallery.length < 7 ? 3 : 2;
    /*---------Set first item to center of gallary*/
    for(let i=0; i<centerGallaryFix; i++) {
        var b = qGallery.pop() as IQuotesGallery;
        qGallery.unshift(b);
    }

    const slideWidth = isMobile() ? 20 : 26;
    const length = qGallery.length;
    const sleep = (ms = 0) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };
    const createItem = (position : number, idx: number, activeIdx: number) => {
        const item = {
            styles: {
                transform: `translateX(${position * slideWidth}rem)`,
                filter: '',
                /*opacity:.5*/
            },
            quote: qGallery[idx],
        };

        switch (position) {
            case length - 1:
            case length + 1:
                item.styles = {...item.styles, filter: 'grayscale(1)'};
                break;
            case length:
                break;
            default:
                item.styles = {...item.styles, /*opacity: 1*/};
                break;
        }

        return item;
    };

    //console.log('qGallery: ',qGallery);

    const CarouselSlideItem = (props:ICarouselSlideItemProps) => {
        const item = createItem(props.pos, props.idx, props.activeIdx);

        return (
            <li className={`carousel__slide-item pos-${props.pos} idx=${props.idx} activeIdx=${props.activeIdx} ${props.isFirst ? "first" : ""} ${props.isLast ? "last" : ""} `} style={item.styles}>
                <div className="carousel__slide-item-wrapper">
                <div className="carousel__slide-item-img-link faded1 faded-all1 dark1 relative ">
                    {/*{<img src={ImageCDNDomain + item.quote.artistImage} alt={item.quote.artistName} />}*/}
                    <Imgix
                        src= {ImageCDNDomain + item.quote.artistImage}
                        sizes={"auto"}
                        htmlAttributes={{
                            alt: `Image for ${ item.quote.artistName }`,
                            loading: 'lazy',
                            width: 1280,
                            height: 720
                        }}
                    />

                    <div className="list-menu-grad-bottom"></div>
                </div>

                <div className="carousel-slide-item__body text-white bg-gray-700">
                    <div className="artist-name text-lg xl:text-2xl font-bold pb1" dangerouslySetInnerHTML={{ __html: item.quote.artistName }} />
                    <div className="artist-title xl:text-lg text-gray-400 mt-2" dangerouslySetInnerHTML={{ __html: item.quote.artistTitle }} />
                    <div className="credits xl:text-lg font-bold mt-2" dangerouslySetInnerHTML={{ __html: item.quote.credits }} />
                    <p className="quote xl:text-lg mt-6" dangerouslySetInnerHTML={{ __html: item.quote.quote }} />
                </div>
                </div>
            </li>
        );
    };

    const keys = Array.from(Array(qGallery.length).keys());

    const Carousel = () => {

        window.addEventListener('DOMContentLoaded', (event) => {

            const elSlider = document.getElementById("carousel__wrap");
            if(!elSlider)
                return;

            //console.log('elSlider el: ',elSlider);
            elSlider.addEventListener('touchstart', handleTouchStart, false);
            elSlider.addEventListener('touchmove', handleTouchMove, false);
        });
        var xDown:any = null;
        var yDown:any = null;

        function getTouches(evt:any) {
            return evt.touches ||             // browser API
                evt.originalEvent.touches; // jQuery
        }

        function handleTouchStart(evt:any) {
            const firstTouch = getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        };

        function handleTouchMove(evt:any) {
            if ( ! xDown || ! yDown ) {
                return;
            }

            const xUp = evt.touches[0].clientX;
            const yUp = evt.touches[0].clientY;

            const xDiff = xDown - xUp;
            const yDiff = yDown - yUp;

            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
                if ( xDiff > 0 ) {
                    /* left swipe */
                    nextClick();
                    //console.log('left swipe');

                } else {
                    prevClick();
                    //console.log('right swipe');
                }
            } else {
                if ( yDiff > 0 ) {
                    /* down swipe */
                } else {
                    /* up swipe */
                }
            }
            /* reset values */
            xDown = null;
            yDown = null;
            //xDown = evt.touches[0].clientX;
            //yDown = evt.touches[0].clientY;
        };

        const [items, setItems] = React.useState(keys);
        const [isTicking, setIsTicking] = React.useState(false);
        const [clickSide, setClickSide] = React.useState('');
        const [activeIdx, setActiveIdx] = React.useState(0);
        const bigLength = items.length;

        const prevClick = (jump = 1) => {
            if (!isTicking) {
                setIsTicking(true);
                setClickSide('prev');
                setItems((prev) => {
                    return prev.map((_, i) => prev[(i + jump) % bigLength]);
                });
            }
        };

        const nextClick = (jump = 1) => {
            if (!isTicking) {
                setIsTicking(true);
                setClickSide('next');
                setItems((prev) => {
                    return prev.map(
                        (_, i) => prev[(i - jump + bigLength) % bigLength],
                    );
                });
            }
        };

        const handleDotClick = (idx: number) => {
            if (idx < activeIdx) prevClick(activeIdx - idx);
            if (idx > activeIdx) nextClick(idx - activeIdx);
        };

        React.useEffect(() => {
            if (isTicking) sleep(300).then(() => setIsTicking(false));
        }, [isTicking]);

        React.useEffect(() => {
            setActiveIdx((length - (items[0] % length)) % length) // prettier-ignore
        }, [items]);

        return (
            <>
            <div id="carousel__wrap" className={"carousel__wrap " + (isMobile() ? "mobile " : "") + ( isTicking ? " effect " : "") + (clickSide) + " arr-len-" + length}>
                <div className="carousel__inner">
                    <div className="carousel_active-frame">
                        <div className="relative h-full">
                        <button aria-label="previous" id="carousel__btn--prev" className="carousel__btn carousel__btn--prev" onClick={() => prevClick()}>
                            {/*<i className="carousel__btn-arrow carousel__btn-arrow--left" />*/}
                            <div className="carousel__btn-arrow--left"><ArrowIcon width="32"></ArrowIcon></div>
                        </button>


                        <button aria-label="next" id="carousel__btn--next" className="carousel__btn carousel__btn--next" onClick={() => nextClick()}>
                            {/*<i className="carousel__btn-arrow carousel__btn-arrow--right" />*/}
                            <div className="carousel__btn-arrow--right"><ArrowIcon width="32"></ArrowIcon></div>
                        </button>
                        </div>
                    </div>
                    <div className="carousel__container">
                        <ul className="carousel__slide-list">
                            {items.map((pos, i, arr) => (
                                <CarouselSlideItem
                                    key={i}
                                    idx={i}
                                    pos={pos+(positionGallaryFix)}
                                    activeIdx={activeIdx}
                                    isFirst={pos === 0}
                                    isLast={pos === arr.length - 1}
                                />
                            ))}
                        </ul>
                    </div>
                    <div className="carousel__dots">
                        {items.slice(0, length).map((pos, i) => (
                            <button aria-label={i === activeIdx ? 'active now' : 'not active'}
                                key={i}
                                onClick={() => handleDotClick(i)}
                                className={i === activeIdx ? 'dot active' : 'dot'}
                            />
                        ))}
                    </div>
                </div>
            </div>
            </>
        );
    };

    return (
        <div className="pb-12">
                <div><Carousel /></div>
        </div>
    )
};

export default QuotesGallery;